var _rect, _circle, _circle2, _line, _line2, _line3, _line4, _rect2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 40,
    height: 32,
    rx: 4,
    fill: "#1A2A52"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 11,
    fill: "none",
    stroke: "#C9A227",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 4,
    fill: "#C9A227"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 22,
    x2: 32,
    y2: 25,
    stroke: "#C9A227",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 39,
    x2: 32,
    y2: 42,
    stroke: "#C9A227",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 32,
    x2: 25,
    y2: 32,
    stroke: "#C9A227",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: 32,
    x2: 42,
    y2: 32,
    stroke: "#C9A227",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 50,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "#C9A227"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 62,
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    fontWeight: "bold",
    fill: "#1A2A52",
    textAnchor: "middle"
  }, "FD")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFd);
export default __webpack_public_path__ + "static/media/fd.1ac3b666ff1a60a26acb4dedb35000c5.svg";
export { ForwardRef as ReactComponent };